import style from "./MobileProductDetail.module.scss";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import { addCommas, clone, decode, rpad2D } from "shared/utils/Utils";
import { storeRequester } from "App";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Flex from "layouts/flex/Flex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Inline from "layouts/container/Inline";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import InputNumber from "components/inputs/InputNumber";
import FixedFooter from "layouts/container/FixedFooter";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import clsx from "classnames";
import Container from "layouts/container/Container";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import { getCustomPriceDisplay, renderPrice } from "shared/utils/Utils";
import Dummy from "components/Dummy";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";


function MobileProductDetail() {
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const { id } = useParams();
  const [product, setProduct] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectVariants, setSelectVariants] = useState([]);
  const inputs = useRef([]);
  const [items, setItems] = useState([]);
  const [isIncrease, setIsIncrease] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0); // 총 금액 상태
  const [mainImage, setMainImage] = useState("");
  const [slideProduct, setSlideProduct] = useState();
  const [displayPrice, setDisplayPrice] = useState(null);

  useEffect(() => {
    if (inputs.current.length > 0) {
      inputs.current.forEach((input, index) => {
        const value = input?.getValue ? input.getValue() : null;

        if (value !== 0) {
          setItems((prevItems) => {
            const updatedItems = prevItems.map((item) =>
              item.index === index ? { ...item, quantity: value } : item
            );
            return updatedItems;
          });
        } else {
          setItems((prevItems) =>
            prevItems.filter((item) => item.index !== index)
          );
        }
      });
    }
  }, [inputs.current, isIncrease]);

  useEffect(() => {
    let searchCondition = clone(initialSearchCondition);
    searchCondition.productId = id;

    storeRequester.getProduct(
      id,
      {
        expand: "images",
        type: "main",
      },
      ({ product }) => {
        // variants를 5개씩 그룹화
        const processedVariants = [];
        const variants = product.variants || [];

        // 첫 번째 그룹은 4개만 포함 (메인 썸네일이 첫 번째 자리를 차지하므로)
        for (let i = 0; i < variants.length; i += 5) {
          const group = variants.slice(i, i + 5);
          // 그룹이 5개가 되지 않으면 빈 객체로 채움
          while (group.length < 5) {
            group.push({});
          }
          processedVariants.push(group);
        }

        setSlideProduct(processedVariants);
        setProduct(product);
        setMainImage(product.thumbnail);
      }
    );
  }, []);


  useEffect(() => {
    if (items && items.length > 0) {
      const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
      setQuantity(totalQuantity);
    }
  }, [items]);

  // 총 금액 계산 함수
  useEffect(() => {
    const total = items.reduce((sum, item) => {
      const variant = product.variants.find(
        (variant) => variant.id === item.variantId
      );

      const price = variant?.discount_price || variant?.price || 0;
      return sum + price * item.quantity;
    }, 0);

    setTotalPrice(total);
  }, [items, product]);

  useEffect(() => {
    let searchCondition = clone(initialSearchCondition);
    searchCondition.productId = id;

    storeRequester.getProduct(
      id,
      {
        expand: "images",
        type: "main",
      },
      ({ product }) => {
        setProduct(product);
        setMainImage(product.thumbnail);
      }
    );
  }, []);

  const handleThumbnailHover = (image) => {
    setMainImage(image);
  };

  const GiftSticker = () => {
    return (
      <>
        {product.gift && (
          <div
            style={{
              width: 50,
              height: 50,
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 100,
              backgroundColor: "#0a8fff",
              borderRadius: "100%",
              padding: "5px 10px",
            }}
          >
            <Center>
              <P
                weight={800}
                color={"white"}
              >{`${product.giftStandard} + ${product.gift}`}</P>
            </Center>
          </div>
        )}
      </>
    );
  };

  const handleInputChange = (variantId, index) => {
    setItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex(
        (item) => item.variantId === variantId
      );
      if (existingItemIndex !== -1) {
        const updatedItems = [...prevItems];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          index: index,
        };
        return updatedItems;
      } else {
        return [...prevItems, { variantId, index: index }];
      }
    });
  };
  const addCartButtonClick = (e) => {
    e.stopPropagation();
    NiceModal.show("mobileAddCart", { product: product });
  };


  useEffect(() => {
    if (product && userName) {
      setDisplayPrice(renderPrice(product, userName));
    }
  }, [product, userName]);


  return (
    <div className={style.wrap}>
      {product && (
        <div className={style.summaryContainer}>
          <VerticalFlex gap={80}>
            <FlexChild>
              <Container maxWidth={1200} borderBottom={'3px solid #ddd'}>
                <Flex
                  direction={isMobile ? "vertical" : "horizontal"}
                  flexStart
                  gap={30}
                >
                  <FlexChild padding={"0 10px"}>
                    <VerticalFlex gap={20}>
                      <FlexChild>
                        <SquareWrapper>
                          <img src={mainImage || product.thumbnail} style={{ width: "100%" }} />
                        </SquareWrapper>
                      </FlexChild>
                      <FlexChild>
                        <div style={{
                          position: 'relative',
                          width: '100%',
                        }}>
                          <div style={{
                            width: '100%',
                            overflow: 'hidden',
                            padding: '0 5px'
                          }}>
                            <Swiper
                              modules={[Navigation]}
                              navigation={{
                                nextEl: '.mobile-product-detail-swiper-next',
                                prevEl: '.mobile-product-detail-swiper-prev',
                              }}
                              slidesPerView={1}
                              spaceBetween={0}
                              style={{
                                width: '100%',
                              }}
                            >
                              {/* 첫 번째 슬라이드: 메인 이미지 + variants 3개 */}
                              <SwiperSlide style={{ width: '100%' }}>
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  width: '100%',
                                }}>
                                  <div
                                    onTouchStart={() => handleThumbnailHover(product.thumbnail)}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center"
                                    }}
                                  >
                                    <img
                                      src={product.thumbnail}
                                      style={{
                                        maxWidth: "70px",
                                        objectFit: 'cover',
                                        // border: mainImage === product.thumbnail ? "1.5px solid var(--main-color)" : "none"
                                      }}
                                    />
                                  </div>
                                  {/* {product.variants.slice(0, 3).map((item, index) => (
                                    <div
                                      key={index}
                                      onTouchStart={() => handleThumbnailHover(item.thumbnail)}
                                      style={{
                                        cursor: "pointer",
                                        // border: mainImage === item.thumbnail ? "1.5px solid var(--main-color)" : "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "2px"
                                      }}
                                    >
                                      <img
                                        src={item.thumbnail}
                                        alt={item.title || `Image ${index}`}
                                        style={{
                                          maxWidth: "70px",
                                          objectFit: 'cover'
                                        }}
                                      />
                                    </div>
                                  ))} */}
                                </div>
                              </SwiperSlide>

                              {/* 나머지 variants를 4개씩 슬라이드로 나누기 */}
                              {Array.from({
                                length: Math.ceil((product.variants.length - 3) / 4)
                              }).map((_, slideIndex) => (
                                <SwiperSlide key={slideIndex} style={{ width: '100%' }}>
                                  <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                  }}>
                                    {(() => {
                                      const currentVariants = product.variants.slice(3 + (slideIndex * 4), 3 + (slideIndex * 4) + 4);
                                      const emptySlots = 4 - currentVariants.length;
                                      const fullSlots = [...currentVariants, ...Array(emptySlots).fill(null)];

                                      return fullSlots.map((item, index) => (
                                        item ? (
                                          <div
                                            key={index}
                                            onTouchStart={() => handleThumbnailHover(item.thumbnail)}
                                            style={{
                                              cursor: "pointer",
                                              // border: mainImage === item.thumbnail ? "1.5px solid var(--main-color)" : "none",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              padding: "2px"
                                            }}
                                          >
                                            <img
                                              src={item.thumbnail}
                                              alt={item.title || `Image ${index}`}
                                              style={{
                                                maxWidth: "70px",
                                                objectFit: 'cover'
                                              }}
                                            />
                                          </div>
                                        ) : (
                                          <div
                                            key={index}
                                            style={{
                                              maxWidth: "70px",
                                              padding: "2px",
                                              visibility: 'hidden',
                                              flexShrink: 0,
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center'
                                            }}
                                          >
                                            <div style={{ width: '100%', height: '100%', background: 'transparent' }} />
                                          </div>
                                        )
                                      ));
                                    })()}
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>

                          <div
                            className="mobile-product-detail-swiper-prev"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: 0,
                              transform: 'translateY(-50%)',
                              zIndex: 10,
                              cursor: 'pointer',
                              width: '20px',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: 'white',
                            }}
                          >
                            <FontAwesomeIcon icon={faAngleLeft} />
                          </div>

                          <div
                            className="mobile-product-detail-swiper-next"
                            style={{
                              position: 'absolute',
                              top: '50%',
                              right: 0,
                              transform: 'translateY(-50%)',
                              zIndex: 10,
                              cursor: 'pointer',
                              width: '20px',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: 'white',
                            }}
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                          </div>
                        </div>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild padding={"0 10px"}>
                    <VerticalFlex gap={10} flexStart>
                      <FlexChild padding={"10px 0px 0px 0px"}>
                        <P size={"7vw"} color={"#222"} weight={700}>
                          {product.title}
                        </P>
                      </FlexChild>
                      <FlexChild justifyContent={"flex-start"}>
                        <P
                          textHover
                          cursor
                          textAlign={"left"}
                          size={isMobile ? 16 : 20}
                          weight={"bold"}
                          color={"rgba(89, 87, 87, 1)"}
                        >
                          {Array.isArray(displayPrice) ? (
                            displayPrice.map((line, index) => (
                              <div key={index}>{line}</div>
                            ))
                          ) : (
                            displayPrice
                          )}
                        </P>
                      </FlexChild>
                    </VerticalFlex>
                  </FlexChild>
                  <FlexChild padding={"0 10px 30px 10px"}>
                    <P size={14} color={"#aaa"}>
                      오후 4시 이전 결제, 주문건 당일출고
                    </P>
                  </FlexChild>
                </Flex>
              </Container>
            </FlexChild>
            <FlexChild alignItems={'flex-start'}>
              <PaddingWrapper padding={"0px 10px"}>
                <Container>
                  {// to-do remove
                    product?.content ? (
                      <QuillViewer
                        value={
                          product.content?.startsWith("PHA")
                            ? decode(product.content)
                            : product.content
                        }
                      />
                    ) : (
                      <img
                        src={product.images?.[0]?.url}
                        style={{ width: "100%" }}
                        alt="empty"
                      />
                    )}
                </Container>
              </PaddingWrapper>
            </FlexChild>
          </VerticalFlex>
        </div>
      )}

      <FixedFooter height={45} maxWidth={1200}>
        <div className={clsx(style.footer, { [style.mobile]: isMobile })}>
          <HorizontalFlex gap={0}>
            <FlexChild height={"100%"}>
              <PaddingWrapper padding={"0px 0px"}>
                <ButtonEclipse
                  text={t("cart")}
                  fontSize={20}
                  // onClick={onPurchaseClick}
                  onClick={addCartButtonClick}
                  height={40}
                  borderRadius={0}
                  backgroundColor={"white"}
                  fontWeight={"bold"}
                  color={"var(--main-color)"}
                  // border={"2px solid var(--main-color)"}
                  border={null}
                />
              </PaddingWrapper>
            </FlexChild>
            <FlexChild height={"100%"}>
              <PaddingWrapper padding={"0px 0px"}>
                <ButtonEclipse
                  text={t("buyNow")}
                  fontSize={20}
                  // onClick={onAddCartClick}
                  onClick={addCartButtonClick}
                  height={40}
                  borderRadius={0}
                  backgroundColor={"var(--main-color)"}
                  fontWeight={"bold"}
                  border={"2px solid var(--main-color)"}
                />
              </PaddingWrapper>
            </FlexChild>
          </HorizontalFlex>
        </div>
      </FixedFooter>
    </div>
  );
}

export default MobileProductDetail;
